<!-- 物流模板管理 -->
<template>
  <div class="">
    <!-- 搜索部分 -->
    <div class="">
      <el-form ref="shippingForm" :model="search_data" :inline="true" label-width="100px" label-position="right"
        size="medium" class="dyh-line-group el-form-class" style="">
        <el-form-item label="模板名称：" prop="template_name">
          <el-input v-model="search_data.template_name" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="配送地区：" prop="delivery_area">
          <el-input v-model="search_data.delivery_area" placeholder="请输入配送地区"></el-input>
        </el-form-item> -->
        <el-form-item prop="template_no" style="margin-left: 20px;">
          <el-button type="primary" @click="filterByTemplateName" plain>查询</el-button>
        </el-form-item>
        <el-form-item prop="template_no" style="margin-left: 20px;">
          <el-button type="primary" @click="createTemplate">新建模板</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格部分 -->
    <div class="dyh-body-group" style="height: calc(100% - 100px);">
      <el-table :row-class-name="tableRowClassName" :data="filteredTemplateList"
        :header-cell-style="{ background: '#66B1FF', color: '#333' }" :height="scroll_height"
        style="width: 100%;margin-bottom: 20px;" row-key="template_no">
        <!-- <el-table-column prop="template_no" align="left" label="模板编号" width="200">
        </el-table-column> -->
        <el-table-column prop="template_name" align="center" label="模板名称" >
        </el-table-column>
        <!-- <el-table-column prop="delivery_area" align="center" label="配送地区">
          <template slot-scope="scope">
            <span>{{ scope.row.delivery_area || '全国' }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="delivery_time" align="center" label="送达时间" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.delivery_time || '3-5' }}天</span>
          </template>
        </el-table-column>
        <el-table-column prop="shipping_fee" align="center" label="运费(元)" width="150">
          <template slot-scope="scope">
            <span>¥{{ scope.row.shipping_fee || '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="free_shipping_threshold" align="center" label="免邮门槛(元)" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.free_shipping_threshold ? '满¥' + scope.row.free_shipping_threshold + '免邮' : '无不设免邮'
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="status" align="center" label="允许组合">
          <template slot-scope="scope">
            <el-tag :type="scope.row.allow_combine === 'True' ? 'success' : 'info'" size="small">
              {{ scope.row.allow_combine === 'True' ? '允许' : '禁止' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === 'True' ? 'success' : 'info'" size="small">
              {{ scope.row.state === 'True' ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作" width="200">
          <template slot-scope="scope">
            <div class="primary-flex-colum " style="justify-content: center;align-items: center;">
              <el-button type="text" size="mini" @click="updateTemplate(scope.row)">修改</el-button>
              <el-button type="text reda-text" size="mini" style="margin: 0px; color: #F56C6C;"
                @click="deleteTemplate(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 模态框部分 -->
    <!-- <el-dialog :title="templateTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px"
      :before-close="handleClose">
      <logistics ref="shippingRef" @templateDialogCancel="templateDialogCancel"></logistics>
    </el-dialog> -->
    <div class="empty-block"></div>
  </div>
</template>

<script>
//import { getShippingTemplateList, shippingTemplateDelete } from '@/api/onlines/shipping'; // 假设的API路径
import { showDialog } from '@/js/public';
import { onlinesShippingtemplateList, onlinesDeleteShippingTemplate } from "@/api/onlines/goods.js";
import { mapMutations } from "vuex";

export default {
  name: "onlineshippingtemplate",
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      dialogVisible: false,
      search_data: { //搜索部分
        template_name: "",
        delivery_area: ""
      },
      allTemplateList: [], //所有物流模板
      filteredTemplateList: [], //过滤后的物流模板
      scroll_height: "",
      templateTitle: "新建物流模板"
    };
  },
  /* eslint-disabled */
  async mounted() {
    this.getTemplateList();
  },
  methods: {
    ...mapMutations("home", ["UPDATEMENUTABS", "CLEARTABS", "ADDTABS"]),
    /**
     * 根据模板名称过滤
     */
    filterByTemplateName() {
      if (!this.search_data.template_name && !this.search_data.delivery_area) {
        // 如果搜索条件为空，显示所有模板
        this.filteredTemplateList = [...this.allTemplateList];
      } else {
        // 根据模板名称和配送地区过滤（模糊搜索）
        const searchName = this.search_data.template_name ? this.search_data.template_name.trim().toLowerCase() : '';
        const searchArea = this.search_data.delivery_area ? this.search_data.delivery_area.trim().toLowerCase() : '';

        this.filteredTemplateList = this.allTemplateList.filter(item => {
          let nameMatch = true;
          let areaMatch = true;

          if (searchName) {
            nameMatch = item.template_name && item.template_name.toLowerCase().includes(searchName);
          }

          if (searchArea) {
            areaMatch = item.delivery_area && item.delivery_area.toLowerCase().includes(searchArea);
          }

          return nameMatch && areaMatch;
        });
      }
    },

    /**
     * 模板对话框取消事件
     */
    templateDialogCancel(e) {
      if (e) {
        this.getTemplateList();
      }
      this.handleClose();
    },

    /**
     * 新建模板
     */
    createTemplate() {
      this.UPDATEMENUTABS("/logistics");
      this.$router.push({ name: 'logistics', params: { key: 'create' } });
      this.ADDTABS({
        activePath: "/logistics",
        title: "物流模板"
      });
    },

    /**
     * 查看模板详情
     */
    viewTemplate(row) {
      this.templateTitle = "查看物流模板";
      this.dialogVisible = true;
      setTimeout(() => {
        this.$refs.shippingRef.setFormData(row, true); // 传入true表示只读模式
      }, 100);
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * 修改模板
     * @param row 选择的行
     */
    updateTemplate(row) {
      /* const that = this;
      this.templateTitle = "修改物流模板";
      this.dialogVisible = true;
      console.log("选择的行数据", row);
      setTimeout(() => {
        that.$refs.shippingRef.setFormData(row);
      }, 100); */
      this.UPDATEMENUTABS("/logistics");
      this.$router.push({ name: 'logistics', params: { key: 'update', value: JSON.stringify(row) } });
      this.ADDTABS({
        activePath: "/logistics",
        title: "物流模板"
      });
    },

    /**
     * 删除模板
     * @param row
     */
    async deleteTemplate(row) {
      if (await showDialog("删除物流模板", "确定要删除该物流模板吗？删除后相关商品将无法使用此模板。")) {
        const res = await onlinesDeleteShippingTemplate(row.template_id);
        if (res.state === true) {
          this.successMessage("物流模板删除成功");
          this.getTemplateList(); // 重新获取列表
        }
      }
    },

    /**
     * 设置行样式
     */
    tableRowClassName({ row, rowIndex }) {
      return '';
    },

    /**
     * 获取所有物流模板
     */
    async getTemplateList() {
      const res = await onlinesShippingtemplateList();
      console.log("获取所有运费模板", res);
      this.allTemplateList = res;
      this.filteredTemplateList = res;
      /* const res = await getShippingTemplateList();

      // 处理返回的数据，添加默认值
      this.allTemplateList = res.map(item => {
        return {
          ...item,
          delivery_area: item.delivery_area || '全国',
          delivery_time: item.delivery_time || '3-5',
          shipping_fee: item.shipping_fee || '0.00',
          free_shipping_threshold: item.free_shipping_threshold || null,
          status: item.status || '1',
          create_time: item.create_time || this.formatDate(new Date())
        };
      });

      console.log("物流模板列表", this.allTemplateList);
      this.filteredTemplateList = [...this.allTemplateList]; */
    },

    /**
     * 成功提示
     */
    successMessage(message) {
      this.$message({
        type: 'success',
        message: message
      });
    },

    /**
     * 格式化日期
     */
    formatDate(date) {
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-table .warning-row {
  background: #ECF5FF !important;
}

.class-table-header {
  background-color: red;
}

.el-form-item {
  margin-bottom: 0px !important;
}

.el-form-class {
  height: 80px;
  justify-content: left;
  padding-left: 20px;
}

.class-lf {
  padding-left: 30px;
}

.class-fa {
  width: 100%;
  height: 100%;
  display: flex;
}

.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}

.r-body {
  width: calc(100% - 500px);
}

.card-right {
  width: auto;
  max-width: 600px;
  height: auto;
  /* background: rgb(205, 230, 255); */
  padding: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

// 操作按钮样式
.primary-flex-colum {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
</style>